import {Setor, Usuario} from '@cdk/models';

export class Responsavel {
    public usuario?: Usuario;
    public setor?: Setor;
    public tipoContato?: string;
}
